<!-- No specific design implemented for back office -->

<div class="radio-card-container" [ngClass]="{ 'has-errors': hasErrors }">
  <boi-validation-error-generic
    (errorChange)="onErrorChange($event)"
    [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames"
  >
  </boi-validation-error-generic>

  <kendo-textbox-container class="w-100">
    <div [ngClass]="cssClasses" class="field-container w-100">
      <div
        *ngIf="radioCardGroupLabel || (labelName | localizeLabel)"
        class="field-label fs-14 mb-10"
        [boiRequiredFormField]="required ? labelName : undefined"
      >
        <label [for]="controlId ? controlId : labelName">
          <span [innerHtml]="radioCardGroupLabel ? radioCardGroupLabel : (labelName | localizeLabel)"></span>
          <boi-tooltip
            *ngIf="!isTooltipLast && showTooltip"
            [tooltipName]="tooltipName ? tooltipName : labelName"
            class="tooltip"
          >
          </boi-tooltip>
        </label>
      </div>
      <div class="field-input d-flex w-100">
        <label
          *ngFor="let option of optionList | localizeOptionList; let index = index"
          class="flex-1 radio-card radio-input"
        >
          <div class="radio-card-header">
            <input
              [attr.name]="controlId ? controlId : labelName"
              [name]="controlId ? controlId : labelName"
              type="radio"
              class="form-radio-button"
              [(ngModel)]="value"
              [disabled]="isFieldDisabled || disabledOptionCodes.indexOf(option.Code) > -1"
              [id]="controlId ? controlId + index : labelName + index"
              [value]="option.Code"
              [required]="required"
            />
            <span class="label" [innerHTML]="option | localizeAttribute : 'Title'"></span>
            <div
              *ngIf="option | localizeAttribute : 'Tag'"
              class="blue-flag"
              [innerHTML]="option | localizeAttribute : 'Tag' | toTrustedHtml"
            ></div>
          </div>
          <div class="card-content" [innerHTML]="option.Value"></div>
        </label>
        <boi-tooltip
          *ngIf="isTooltipLast && showTooltip"
          [tooltipName]="tooltipName ? tooltipName : labelName"
          class="tooltip"
        >
        </boi-tooltip>
      </div>
    </div>
  </kendo-textbox-container>
</div>
